import * as React from 'react';

import {CircularProgressbarWithChildren} from 'react-circular-progressbar';

import SectionProgress from '../FerrariIcon/SectionProgress';
import SectionComplete from '../FerrariIcon/SectionComplete';
import Personal from '../FerrariIcon/Personal';

import InactiveSection from './InactiveSection';

import 'react-circular-progressbar/dist/styles.css';
import s from './ProgressBar.module.css';

export default function ActiveSection(props) {
  const {sectionProgress, sectionName, order} = props;

  if (sectionName === order.getIn([3])) {
    return (
      <div className={s.PersonalWrapper}>
        <Personal
          color={sectionProgress === 100 ? '#fff200' : '#707070'}
          className={s.PersonalIcon}
        />

        <div className={s.activeIconPersonal}>
          {sectionProgress < 100 ? (
            <SectionProgress className={s.ProgressDots} />
          ) : (
            <SectionComplete className={s.ProgressCheck} />
          )}
        </div>
      </div>
    );
  } else if (sectionProgress < 100) {
    return (
      <div className={s.ProgressSectionWrapper}>
        <div className={s.ProgressWrapper}>
          <CircularProgressbarWithChildren
            value={sectionProgress}
            styles={{
              // Customize the root svg element
              root: {},
              // Customize the path, i.e. the "completed progress"
              path: {
                // Path color
                filter: 'blur(1px)',
                stroke: '#fff200',
                strokeWidth: '8px',
                // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
                strokeLinecap: 'square',
                // Customize transition animation
                transition: 'stroke-dashoffset 0.5s ease 0s',
                // Rotate the path
                transformOrigin: 'center center',
              },
              // Customize the circle behind the path, i.e. the "total progress"
              trail: {
                // Trail color
                stroke: '#fff200',
                strokeWidth: '1px',
                // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
                strokeLinecap: 'butt',
                // Rotate the trail
                transform: 'rotate(0.25turn)',
                transformOrigin: 'center center',
              },
            }}
          >
            <div className={s.activeIcon}>
              <SectionProgress className={s.ProgressDots} />
            </div>
          </CircularProgressbarWithChildren>
        </div>
      </div>
    );
  } else if (sectionProgress == 100) {
    return (
      <div className={s.CompletedWrapper}>
        <CircularProgressbarWithChildren
          value={sectionProgress}
          styles={{
            // Customize the root svg element
            root: {
              // height: '90%',
              // width: '90%',
            },
            // Customize the path, i.e. the "completed progress"
            path: {
              // Path color
              filter: 'blur(1px)',
              stroke: '#fff200',
              // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
              strokeLinecap: 'square',
              // Customize transition animation
              transition: 'stroke-dashoffset 0.5s ease 0s',
              // Rotate the path

              transformOrigin: 'center center',
            },
            // Customize the circle behind the path, i.e. the "total progress"
            trail: {
              // Trail color
              stroke: '#f5ff00',
              strokeWidth: '1px',
              // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
              strokeLinecap: 'butt',
              // Rotate the trail
              transform: 'rotate(0.25turn)',
              transformOrigin: 'center center',
            },
          }}
        >
          <div className={s.completedActiveIcon}>
            <SectionComplete className={s.ProgressCheck} />
          </div>
        </CircularProgressbarWithChildren>
      </div>
    );
  } else {
    return <InactiveSection />;
  }
}
